var version = {
    "name":      "dativery",
    "buildDateCode": "20260417-144735",
    "buildDate": "Fri Apr 17 2026 14:47:35 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260417-144735",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;